import styled from '@emotion/styled';

import { spacing, typography } from '$variables/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const AssignmentColumn = styled.div`
  ${({ totalAssignments }) =>
    totalAssignments > 3
      ? 'width: 150px'
      : `width: calc(100% / ${totalAssignments} - 18px)`};
  padding: 22px ${spacing.small} 0 ${spacing.small};
`;

export const Header = styled.div`
  font-weight: ${typography.fontWeightSemiBold};

  height: 42px;

  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
`;
